import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import CarHomeDetailsModal from '../../../components/modal/car-home-details/CarHomeDetailsModal';
import ComoFunciona from '../../../components/como-funciona/ComoFunciona';
import '../../../components/como-funciona/help-circle-btn.css';
import { HOME } from '../../home/routes';
import TelaoOficina from '../TelaoOficina';
import { SECOES_DE_AJUDA_DO_TELAO } from '../ajudaDoTelao';

/**
 * Rota `/telao` (at-130): o Telão em tela cheia, sem o menu — para ficar aberto na TV da oficina.
 *
 * ⚠️ A rota está na lista do `shouldRenderSidebar` do `App.tsx`; sem isso a TV mostraria o menu
 * por cima (armadilha das três ocorrências, `03-code-conventions.md`).
 */
const SEGUNDOS_PARA_FECHAR_O_MODAL = 30;

const TelaoPage: React.FC = () => {
  const navigate = useNavigate();
  const [carId, setCarId] = useState<string | null>(null);
  const [ajudaAberta, setAjudaAberta] = useState(false);

  useEffect(() => {
    const anterior = document.title;
    document.title = 'Telão — SOAC';
    return () => {
      document.title = anterior;
    };
  }, []);

  const fecharModal = useCallback(() => setCarId(null), []);

  return (
    <>
      <TelaoOficina
        modo="telaCheia"
        modalAberto={carId !== null || ajudaAberta}
        onAbrirVeiculo={setCarId}
        onSair={() => {
          if (document.fullscreenElement) document.exitFullscreen?.().catch(() => undefined);
          navigate(HOME());
        }}
        onAjuda={() => setAjudaAberta(true)}
      />
      <CarHomeDetailsModal
        isOpen={carId !== null}
        carId={carId}
        onCancel={fecharModal}
        isSidebarOpen={false}
        fecharEmSegundos={SEGUNDOS_PARA_FECHAR_O_MODAL}
      />
      <ComoFunciona
        isOpen={ajudaAberta}
        onClose={() => setAjudaAberta(false)}
        titulo="Como Funciona — Telão da oficina"
        secoes={SECOES_DE_AJUDA_DO_TELAO}
      />
    </>
  );
};

export default TelaoPage;
